<div
  @fade
  class="people-preview-container"
  data-cy="people-preview-container"
  [ngClass]="{
    'people-preview': previewType === 'people' ,
    'relevant-people-preview': previewType === 'relevant-people',
  }"
>
  <div *ngIf="size === 'full'" class="people-preview-division-line"></div>
  <preview-header
    [personIndex]="personIndex"
    [isFavorite]="isFavorite"
    [size]="size"
    class="people-preview-header"
    [model]="model"
    [details]="person?.details"
    [searchId]="telemetrySearch?.search?.searchId"
    [isLauncher]="isLauncher"
    (closePopup)="onClosePopup()"
    [componentFocused]="childComponentFocused"
    (componentFocusedExit)="onComponentFocusedExit($event)"
    (readyForFocus)="addChild($event)"
    [smallWidthPreview]="smallWidthPreview"
    [extraSmallWidthPreview]="extraSmallWidthPreview"
    [previewPopupLarge]="previewPopupLarge"
  ></preview-header>
  <div
    id="people_preview_content"
    #people_preview_content
    [ngClass]="{
      'people-preview-vertical': size === 'popup' || size === 'side' || extraSmallWidthPreview,
      'people-preview-horizontal': previewPopupLarge || size === 'full',
      'people-preview-popup-state': size === 'popup',
      'people-preview-single-state': size === 'full',
      'people-preview-large': (!smallWidthPreview && size !== 'popup') || previewPopupLarge,
      'people-preview-small': extraSmallWidthPreview,
      'people-preview-popup-large': previewPopupLarge
    }"
  >
    <ng-scrollbar visibility="hover" class="virtual-scroll" [style.height]="scrollHeight">
      <cdk-virtual-scroll-viewport smoothScroll [itemSize]="20" scrollViewport [class.virtual-scroll]="true">
        <div class="people-preview-content-wrapper" [class.hide-hierarchy]="hiddenHierarchy">
          <div class="people-preview-details-wrapper" [ngClass]="{ 'details-wrapper-launcher': isLauncher }">
            <preview-details
              [personIndex]="personIndex"
              [size]="size"
              class="people-preview-details"
              [details]="person?.details"
              [model]="model"
              *ngIf="existDetails()"
              (componentFocusedExit)="onComponentFocusedExit($event)"
              [componentFocused]="childComponentFocused"
              [direction]="childComponentFocused.compIndex === 2 ? childComponentFocused.direction : null"
              (readyForFocus)="addChild($event)"
              [smallWidthPreview]="smallWidthPreview"
              [previewPopupLarge]="previewPopupLarge"
              [searchId]="telemetrySearch?.search?.searchId"
            ></preview-details>
            <preview-hierarchy
              #hierarchy
              *ngIf="!hiddenHierarchy"
              [size]="size"
              (selectedItemToPopUp)="openPopup($event)"
              [details]="person?.details"
              class="people-preview-details people-preview-hierarchy"
              (componentFocusedExit)="onComponentFocusedExit($event)"
              [componentFocused]="childComponentFocused"
              (readyForFocus)="addChild($event)"
              [smallWidthPreview]="smallWidthPreview"
              [previewPopupLarge]="previewPopupLarge"
            >
            </preview-hierarchy>
          </div>
          <div class="people-preview-division-line people-preview-division-line-second"></div>
          <preview-results
            *ngIf="previewType === 'relevant-people'"
            [size]="size"
            [results]="results"
            class="preview-results"
            [userName]="person?.details?.firstName"
            [userEmail]="person?.details?.email"
            (componentFocusedExit)="onComponentFocusedExit($event)"
            [componentFocused]="childComponentFocused"
            (readyForFocus)="addChild($event)"
            [telemetrySearch]="telemetrySearch"
            [smallWidthPreview]="smallWidthPreview"
            [previewPopupLarge]="previewPopupLarge"
            [previewType]="previewType"
          >
          </preview-results>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-scrollbar>
  </div>
</div>
